import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, signal, ViewChild } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe } from "@ngx-translate/core";
import { LottieComponent } from "ngx-lottie";
import { interval, Subscription } from "rxjs";
import { CountDownTimerComponent } from "src/app/components/count-down-timer/count-down-timer.component";
import { VoucherService } from "src/app/services/vouchers.service";
import type { SwiperOptions } from "swiper/types";
import { SwiperComponent, SwiperModule } from "swiper/angular";
import { VoucherManagementService } from './../../services/voucher-management.service';

@Component({
  selector: "app-vouchers-slider",
  templateUrl: "./vouchers-slider.component.html",
  styleUrls: ["./vouchers-slider.component.scss"],
  standalone: true,
  imports: [IonicModule, CommonModule, SwiperModule, TranslatePipe, CountDownTimerComponent, LottieComponent],
})
export class VouchersSliderComponent implements OnInit, OnDestroy {
  @Input() vouchers: any[] | null = null;
  @Input() sliderOptions: SwiperOptions | null = null;
  @Output() voucherSelected = new EventEmitter<any>();

  @ViewChild("slider") slider: SwiperComponent;
  isChecked = signal<boolean>(false);
  public voucherList: any[] = [];
  private expirySub: Subscription;

  constructor(private voucherService: VoucherService, private voucherManagementService: VoucherManagementService) { }

  ngOnInit(): void {
    if (this.vouchers && this.vouchers.length > 0) {
      this.voucherList = this.vouchers.map((v) => ({ ...v }));
    } else {
      this.voucherService.getVoucherList().subscribe((res: any[]) => {
        const currentTime = new Date().getTime();
        this.voucherList = res
          .filter((voucher) => {
            const voucherExpiryDate = voucher?.expiry_date?.toDate?.()?.getTime?.() ?? 0;
            return voucher?.discount_voucher === true && voucher?.isRedeemed === false && voucherExpiryDate > currentTime;
          })
          .map((voucher) => ({ ...voucher, isSelected: false, isDisabled: false, changeExpiryText: false }));
      });
    }

    // Start expiry check
    this.expirySub = interval(1000).subscribe(() => {
      const now = new Date().getTime();
      this.voucherList = this.voucherList.filter((voucher) => {
        try {
          const expiry = voucher.expiry_date?.toDate?.()?.getTime?.() ?? 0;
          const remaining = expiry - now;
          if (remaining > 0 && remaining <= 60000) {
            const idx = this.voucherList.findIndex((v) => v.id === voucher.id);
            if (idx !== -1) this.voucherList[idx].changeExpiryText = true;
          }
          if (remaining <= 0) {
            // remove expired
            return false;
          }
          return true;
        } catch (e) {
          return false;
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.expirySub?.unsubscribe();
  }
  onSelectVoucher(event$: any, voucher: any) {
    // if selected, validate via lookup
    this.isChecked.set(event$?.detail?.checked ?? voucher?.isSelected);
    this.voucherManagementService.isChecked.set(event$?.detail?.checked ?? voucher?.isSelected);
    this.voucherManagementService.typeOfVoucher.set("manual");
    const voucherEventsMixPanel = this.voucherManagementService.typeOfVoucher();
    if (event$?.detail?.checked) {
      this.voucherService.getVoucherLookupData(voucher.voucher_code).subscribe((data: any[]) => {
        if (data && data.length > 0) {
          const voucherData = data[0];
          const voucherExpiryDate = voucherData.end_date?.toDate?.()?.getTime?.() ?? 0;
          const now = new Date().getTime();
          if (voucherData.status && voucherExpiryDate > now) {
            this.voucherService.updateDiscountVoucherHideStatus(voucher.id, false);
            voucher.isSelected = true;
            this.voucherSelected.emit({ event: event$, voucher, voucherEventsMixPanel });
          } else {
            this.voucherService.updateDiscountVoucherHideStatus(voucher.id, true);
            // remove invalid
            this.voucherList = this.voucherList.filter((v) => v.id !== voucher.id);
          }
        }
      });
    } else {
      // deselect -> reset
      voucher.isSelected = false;
      this.voucherSelected.emit({ event: event$, voucher, voucherEventsMixPanel });
    }
  }
}
